import { Seo } from "@/components/Seo";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowUpRight } from "lucide-react";

export default function PostupakPage() {
  const { t } = useTranslation();
  const steps = t("postupak.steps", { returnObjects: true });
  const stepsArr = Array.isArray(steps) ? steps : [];

  return (
    <div data-testid="postupak-page">
      <Seo title={t("postupak.seoTitle")} path="/postupak-legalizacije" description={t("postupak.seoDesc")} />
      {/* HERO */}
      <section className="border-b border-hair">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 pt-20 pb-16 lg:pt-28 lg:pb-20">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
            <div className="md:col-span-8">
              <div className="overline text-ink-soft flex items-center gap-3">
                <span className="w-8 h-px bg-ink-soft/40" /> {t("postupak.kicker")}
              </div>
              <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[0.95] font-bold text-ink mt-6">
                {t("postupak.heroTitle1")}<br />{t("postupak.heroTitle2")}<br />
                <span className="text-ink/40">{t("postupak.heroTitle3")}</span>
              </h1>
            </div>
            <div className="md:col-span-4 text-ink-soft leading-relaxed">
              {t("postupak.heroLead")}
            </div>
          </div>
        </div>
      </section>

      {/* TIMELINE */}
      <section className="max-w-[1400px] mx-auto px-6 lg:px-12 py-20 lg:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-3">
            <div className="md:sticky md:top-24">
              <div className="overline text-ink-soft">{t("postupak.phasesKicker")}</div>
              <p className="text-ink-soft text-sm mt-4 leading-relaxed">
                {t("postupak.phasesNote")}
              </p>
              <Link
                to="/prijava"
                data-testid="postupak-cta"
                className="inline-flex items-center gap-2 mt-6 bg-ink text-white px-5 py-3 text-sm font-medium rounded-sm hover:bg-[#112240] transition-colors"
              >
                {t("common.applyNow")}
                <ArrowUpRight className="w-4 h-4" strokeWidth={1.75} />
              </Link>
            </div>
          </div>

          <div className="md:col-span-9 relative">
            <div className="absolute left-0 top-0 bottom-0 w-px bg-ink/15 hidden md:block" />
            <ol className="space-y-0">
              {stepsArr.map((s, idx) => {
                const n = `0${idx + 1}`;
                const bullets = Array.isArray(s.bullets) ? s.bullets : [];
                return (
                  <li
                    key={n}
                    className="relative md:pl-12 py-8 border-b border-hair last:border-b-0"
                    data-testid={`step-${n}`}
                  >
                    <span className="hidden md:block absolute left-0 top-10 -translate-x-1/2 w-3 h-3 bg-ink rotate-45" />
                    <div className="grid grid-cols-12 gap-6 items-start">
                      <div className="col-span-12 md:col-span-2">
                        <div className="font-display text-5xl text-ink/15 font-bold leading-none">
                          {n}
                        </div>
                        <div className="overline text-ink-soft mt-3">{s.duration}</div>
                      </div>
                      <div className="col-span-12 md:col-span-10">
                        <h3 className="font-display text-2xl sm:text-3xl font-semibold tracking-tight text-ink">
                          {s.title}
                        </h3>
                        <p className="text-ink-soft mt-3 leading-relaxed max-w-2xl">
                          {s.desc}
                        </p>
                        <ul className="mt-5 grid grid-cols-1 sm:grid-cols-3 gap-2 max-w-2xl">
                          {bullets.map((b) => (
                            <li
                              key={b}
                              className="text-sm text-ink border border-hair px-3 py-2 bg-white"
                            >
                              {b}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </li>
                );
              })}
            </ol>
          </div>
        </div>
      </section>

      {/* Bottom note */}
      <section className="border-t border-hair surface">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
          <div className="md:col-span-8">
            <div className="overline text-ink-soft">{t("postupak.noteKicker")}</div>
            <p className="text-ink mt-3 leading-relaxed max-w-3xl">
              {t("postupak.note")}
            </p>
          </div>
          <div className="md:col-span-4 md:text-right">
            <Link
              to="/zakonski-propisi"
              className="inline-flex items-center gap-2 border border-ink text-ink px-5 py-3 text-sm font-medium rounded-sm hover:bg-white transition-colors"
            >
              {t("postupak.lawsLink")}
              <ArrowUpRight className="w-4 h-4" strokeWidth={1.75} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
